import { defineOnboardingSection } from "onboarding/utils";

const orderedSteps = [
  "Name",
  "Regions",
  "Services",
  "Policy",
  "Role",
  "Data",
  "Initialization",
  "Done",
];

export const AWS_TRACK = defineOnboardingSection({
  orderedSteps,
  prefix: "AWS ",
  sectionName: "aws",
  steps: orderedSteps.concat(["Invite", "Complete"]),
});
export default AWS_TRACK;
